import React, { useCallback, useMemo, useState } from 'react'
import Button from './Button'
import StyledForm, {
    Input,
    Select,
    TextArea,
    withStyledInputGroup,
} from './Form.ui'

import set from 'lodash/set'
import get from 'lodash/get'
import ColorInput from './InputColor'
import InputImage from './InputImage'
import { DangerBanner } from './Banner'
import Captcha from './Captcha'
import { startCase } from 'lodash'

//
const defaultFormComponents = {
    color: (p) => <Input {...p} Component={ColorInput} />,
    textarea: TextArea,
    checkbox: ({ value, onChange, ...props }) => (
        <Input
            {...props}
            checked={value}
            onChange={({ target: { checked } }) => onChange(checked)}
        ></Input>
    ),
    image: InputImage,
    hidden: (p) => <input type="hidden" {...p} />,
    select: Select,
    captcha: withStyledInputGroup(Captcha),
}
const MakeComponent =
    ({ formState, setFormState, FormComponents, props, noEdit }) =>
    ({
        options,
        name,
        label,
        placeholder,
        required,
        type,
        span,
        style,
        column = 'span 4',
        row,
        component: Component = FormComponents[type] || Input,
        step,
        max,
        withInitialValue,
        conditionalRender,
        props: _elementProps,
    }) => {
        const val = get(formState, name)
        const value = val || (withInitialValue && withInitialValue(props))
        if (conditionalRender && !conditionalRender(formState)) return null
        return (
            <Component
                style={{
                    gridColumn: column,
                    ...(row && { gridRow: row }),
                    ...style,
                }}
                {...{
                    name,
                    label,
                    placeholder,
                    key: name + label,
                    required,
                    type,
                    value,
                    span,
                    formState,
                    options,
                    step,
                    max,
                    noEdit,
                    ...props,
                    ..._elementProps,
                }}
                onChange={(e) => {
                    if (noEdit) return
                    const val = e?.target?.value
                    if (typeof val !== 'undefined')
                        return setFormState((v) => set({ ...v }, name, val))
                    return setFormState((v) => set({ ...v }, name, e))
                }}
            />
        )
    }
const FormCreator = ({
    initialValues = {},
    fields,
    onSubmit,
    onDelete,
    onChange,
    FormComponents = defaultFormComponents,
    title,
    errorLabel = 'Something went wrong...',
    submitText = 'Submit',
    noEdit = false,
    initialFormState: _initialFormState,
    ...props
}) => {
    const initialFormState =
        _initialFormState ||
        fields.reduce(
            (acc, { withInitialValue, name }) =>
                withInitialValue
                    ? {
                          ...acc,
                          [name]: withInitialValue(props),
                      }
                    : acc,
            initialValues || {}
        )
    const [formState, setFormState] = useState(initialFormState)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState()
    const FieldComponents = useMemo(
        () =>
            noEdit
                ? fields.map(
                      MakeComponent({
                          formState,
                          setFormState,
                          FormComponents,
                          props,
                          noEdit,
                      })
                  )
                : fields.map(
                      MakeComponent({
                          formState,
                          setFormState,
                          FormComponents,
                          props,
                          noEdit,
                      })
                  ),
        [noEdit, fields, formState]
    )
    return (
        <React.Fragment>
            <StyledForm
                style={props.style || {}}
                onSubmit={(e) => {
                    if (isSubmitting) return
                    setIsSubmitting(true)
                    e.preventDefault()
                    //todo:validate
                    onSubmit?.(formState)
                        ?.catch((error) =>
                            // void console.error('ERRORO', error) ||
                            setError(error)
                        )
                        .then((r) => {
                            setIsSubmitting(false)
                        })
                }}
            >
                {title && (
                    <h2>
                        {typeof title === 'function' ? title(props) : title}
                    </h2>
                )}
                <div className="form-body">{FieldComponents}</div>
                <div className="form-footer">
                    {(onDelete || onDelete) && (
                        <Button
                            onClick={(e) =>
                                void e.preventDefault() || onDelete()
                            }
                            type="button"
                        >
                            Delete
                        </Button>
                    )}
                    {(onSubmit || onSubmit) && !noEdit && (
                        <Button disabled={isSubmitting}>{submitText}</Button>
                    )}
                </div>
                {error && (
                    <DangerBanner
                        onClick={() => {
                            setError()
                        }}
                    >
                        {errorLabel}
                    </DangerBanner>
                )}
            </StyledForm>
        </React.Fragment>
    )
}

export default FormCreator
